var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100"},[(_vm.tempGraph)?_c('div',{attrs:{"id":"chartTemp"}}):_vm._e(),(_vm.humiGraph)?_c('div',{attrs:{"id":"chartHumi"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }